import { render } from "./SpurProfile.vue?vue&type=template&id=31b76bb9&scoped=true&ts=true"
import script from "./SpurProfile.vue?vue&type=script&lang=ts"
export * from "./SpurProfile.vue?vue&type=script&lang=ts"

import "./SpurProfile.vue?vue&type=style&index=0&id=31b76bb9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1364277118/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b76bb9"]])

export default __exports__